import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["unavailableCheck", "priceField", "statusLabel"];

  connect() {
    // Initialize state on load
    this.togglePriceField();
    this.updateStatusLabel();
  }

  toggleAvailability(event) {
    this.togglePriceField();
    this.updateStatusLabel();
  }

  togglePriceField() {
    if (!this.hasPriceFieldTarget || !this.hasUnavailableCheckTarget) return;

    if (this.unavailableCheckTarget.checked) {
      // Disable and clear price field when unavailable is checked
      this.priceFieldTarget.disabled = true;
      this.priceFieldTarget.value = "0";
      this.priceFieldTarget.classList.add("bg-gray-100", "dark:bg-gray-700", "cursor-not-allowed", "opacity-50");
      this.priceFieldTarget.classList.remove("bg-white", "dark:bg-gray-800", "opacity-100");
    } else {
      // Enable price field
      this.priceFieldTarget.disabled = false;
      this.priceFieldTarget.classList.remove("bg-gray-100", "dark:bg-gray-700", "cursor-not-allowed", "opacity-50");
      this.priceFieldTarget.classList.add("bg-white", "dark:bg-gray-800", "opacity-100");
    }
  }

  updateStatusLabel() {
    if (!this.hasStatusLabelTarget || !this.hasUnavailableCheckTarget) return;

    if (this.unavailableCheckTarget.checked) {
      // Show "구매 불가" in red
      this.statusLabelTarget.innerHTML = '<span class="text-red-600 dark:text-red-400">구매 불가</span>';
    } else {
      // Show "구매 가능" in green
      this.statusLabelTarget.innerHTML = '<span class="text-green-600 dark:text-green-400">구매 가능</span>';
    }
  }
}